import React, { FC } from 'react';
import styled from 'styled-components';

import SecureInput, { ISecureInputProps } from '@ui/atoms/SecureInput';

interface ISsnInputProps extends ISecureInputProps {}

const SsnInput: FC<ISsnInputProps> = ({ label, name, ...splatProps }) => {
	const changeHandler = (iVal: string, rawVal: string) => {
		let newSSN = '';

		if (rawVal.length > 5) {
			newSSN = rawVal.slice(0, 5) + iVal.slice(5, iVal.length);
		} else {
			const lastChar = iVal.slice(-1);
			newSSN = rawVal + lastChar;
		}

		if (rawVal.length >= 9) {
			return rawVal;
		}

		return newSSN;
	};

	const cleanValue = (value: string) => {
		return value.replace(/-/g, '');
	};

	const formatter = (value: string) => {
		value = value.slice(0, 11).replace(/-/g, '');

		if (value.length <= 3) {
			return value;
		}

		if (value.length > 3 && value.length <= 5) {
			return `${value.slice(0, 3)}-${value.slice(3)}`;
		}

		if (value.length > 5) {
			return `${value.slice(0, 3)}-${value.slice(3, 5)}-${value.slice(5)}`;
		}

		return value;
	};

	const masker = (raw: string) => {
		const newMasked = raw.slice(0, 7).replace(/[0-9]/g, '•');
		const final = newMasked + raw.slice(7);

		return final;
	};

	return (
		<SecureInput
			label={label}
			name={name}
			changeHandler={changeHandler}
			cleanValue={cleanValue}
			formatter={formatter}
			masker={masker}
			inputType="Social Security Number"
			{...splatProps}
		/>
	);
};

export default styled(SsnInput)``;
